import React, { useState } from "react";
import { compose } from "redux";
import { withStyles } from "components/common";

const moment = require("moment");

const median = arr => {
  const arrSort = arr.sort();
  const mid = Math.ceil(arr.length / 2);
  const md = arr.length % 2 === 0
    ? (arrSort[mid] + arrSort[mid - 1]) / 2
    : arrSort[mid - 1];
  return md;
}
const average = arr => {
  return arr.reduce((total, b) => total + b, 0) / arr.length;
}

const showDerivedFinancialData = (user) => {
    if (user.derived_financial_data){
      const { currentBalance, otherCredit, otherCreditCard, minCreditCardLimit, oldestBankAge, decisionKeys } = user.derived_financial_data || {};
      const { current_dda_balance: newCurrentBalance } = decisionKeys || {};
      return (
        <div>
          <div>Current Balance: <span className="font-bold">${(currentBalance || newCurrentBalance || 0).toFixed(2)}</span></div>
          <div>Other Credit: <span className="font-bold">${(otherCredit || 0).toFixed(2)}</span></div>
          <div>Other Credit Card: <span className="font-bold">${(otherCreditCard || 0).toFixed(2)}</span></div>
          <div>Min Credit Card Limit: <span className="font-bold">${(minCreditCardLimit || 0).toFixed(2)}</span></div>
          <div>Oldest Bank Age: <span className="font-bold">{oldestBankAge} days</span></div>
        </div>
      )
  }
}

const UnderwritingDataBox = ({ user, assetData = {}, transactionReport = {} }) => {
  // console.log(assetData);
  const accts = [];
  if (assetData && assetData.report) {
    (assetData.report || {}).items.forEach(i => {
      accts.push(...i.accounts);
    })
  };

  const { institutions } = transactionReport || {};
  if (institutions && institutions.length > 0) {
    // console.dir(institutions);
    institutions.forEach(i => {
      (i.accounts || []).forEach(a => {
        const hist_bal = (a.generatedHistoricalBalances || [])
          .sort((b1, b2) => moment(b1.date) - moment(b2.date))
          .slice(Math.max(0, a.generatedHistoricalBalances.length - 180));

        accts.push({
          label: a.id,
          type: ['checking', 'savings'].includes(a.type) ? 'depository' : 'non-depository',
          subtype: a.type,
          name: a.name,
          historical_balances: hist_bal
        });
      })
    });
  };
  // console.dir(accts)

  const asset_accounts = accts.filter(a => a.type !== 'depository');
  const depository_accts = accts.filter(a => a.type === 'depository');
  depository_accts.forEach(da => {
    da.historical_balances = da.historical_balances.reverse();
  });
  const avg6 = depository_accts
    .map(a => average(a.historical_balances.map(b => b.current)))
    .reduce((a, b) => a + b, 0);
  const avg3 = depository_accts
    .map(a => average(a.historical_balances.slice(0,90).map(b => b.current)))
    .reduce((a, b) => a + b, 0);
  const avg1 = depository_accts
    .map(a => average(a.historical_balances.slice(0,30).map(b => b.current)))
    .reduce((a, b) => a + b, 0);
  const med6 = depository_accts
    .map(a => median(a.historical_balances.map(b => b.current)))
    .reduce((a, b) => a + b, 0);
  const med1 = depository_accts
    .map(a => median(a.historical_balances.slice(0, 30).map(b => b.current)))
    .reduce((a, b) => a + b, 0);
  
  return (
    <div className="mt-5 mb-5 border border-gray-400 p-3">
      <h1 className="text-2xl font-title mb-2 font-light">
        Underwriting Parameters
      </h1>
      <div>{user.is_student ? "IS A STUDENT" : ""}</div>
      <div>depository 6-mo average: <span className="font-bold">${avg6.toFixed(2)}</span></div>
      <div>depository 3-mo average: <span className="font-bold">${avg3.toFixed(2)}</span></div>
      <div>depository 1-mo average: <span className="font-bold">${avg1.toFixed(2)}</span></div>
      <div>depository 6-mo median: <span className="font-bold">${med6.toFixed(2)}</span></div>
      <div>depository 1-mo median: <span className="font-bold">${med1.toFixed(2)}</span></div>
      {showDerivedFinancialData(user)}
    </div>
  );
}

export default compose(withStyles)(UnderwritingDataBox);
